function initSwipers(scope = document) {

  const sliders = scope.querySelectorAll(".fr-swiper");
  if (!sliders.length) return;

  sliders.forEach(function (slider) {

    // Prevent duplicate initialization
    if (slider.swiper) return;

    /* =========================
       READ SETTINGS
    ========================= */

    const slidesDesktop = parseInt(slider.dataset.slides) || 3;
    const slidesTablet = parseInt(slider.dataset.slidesTablet) || 2;
    const slidesMobile = parseInt(slider.dataset.slidesMobile) || 1;

    const spaceDesktop = parseInt(slider.dataset.space) || 0;
    const spaceTablet = parseInt(slider.dataset.spaceTablet) || spaceDesktop;
    const spaceMobile = parseInt(slider.dataset.spaceMobile) || spaceTablet;

    const speed = parseInt(slider.dataset.speed) || 500;
    const delay = parseInt(slider.dataset.delay) || 4000;

    const autoplayEnabled = slider.dataset.autoplay === "true";
    const loopEnabled = slider.dataset.loop !== "false";

    /* ✅ NEW: Effect support */
    const effect = slider.dataset.effect || "slide";

    /* =========================
       EFFECT-SPECIFIC SETTINGS
    ========================= */

    let extraSettings = {};

    if (effect === "coverflow") {
      extraSettings = {
        centeredSlides: true,
        slidesPerView: "auto"
      };
    }

    if (effect === "fade") {
      extraSettings = {
        slidesPerView: 1
      };
    }

    /* =========================
       INIT SWIPER
    ========================= */

    const swiperInstance = new Swiper(slider, {

      effect: effect,

      /* Mobile first */
      slidesPerView: slidesMobile,
      spaceBetween: spaceMobile,
      speed: speed,

      loop: loopEnabled,
      watchOverflow: true,

      observer: true,
      observeParents: true,

      autoplay: autoplayEnabled
        ? {
            delay: delay,
            disableOnInteraction: false
          }
        : false,

      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev")
      },

      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true
      },

      /* =========================
         EFFECT CONFIGS
      ========================= */

      fadeEffect: {
        crossFade: true
      },

      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1.5,
        slideShadows: false
      },

      flipEffect: {
        slideShadows: true,
        limitRotation: true
      },

      creativeEffect: {
        prev: {
          translate: ["-120%", 0, -500]
        },
        next: {
          translate: ["120%", 0, -500]
        }
      },

      /* =========================
         BREAKPOINTS
      ========================= */

      breakpoints: {

        768: {
          slidesPerView: slidesTablet,
          spaceBetween: spaceTablet
        },

        990: {
          slidesPerView: slidesDesktop,
          spaceBetween: spaceDesktop
        }

      },

      /* Merge extra settings */
      ...extraSettings,

      on: {
        init() {
          slider.classList.add("swiper-ready");
        }
      }

    });

    /* =========================
       AUTOPLAY TOGGLE
    ========================= */

    const toggleBtn = slider.querySelector(".fr-swiper-toggle");

    if (toggleBtn && swiperInstance.autoplay) {

      toggleBtn.addEventListener("click", function () {

        if (swiperInstance.autoplay.running) {
          swiperInstance.autoplay.stop();
          toggleBtn.textContent = "Play";
        } else {
          swiperInstance.autoplay.start();
          toggleBtn.textContent = "Pause";
        }

      });

    }

  });

}


/* =========================
   PAGE LOAD
========================= */
document.addEventListener("DOMContentLoaded", function () {
  initSwipers();
});


/* =========================
   SHOPIFY THEME EDITOR
========================= */
document.addEventListener("shopify:section:load", function (event) {
  initSwipers(event.target);
});


/* =========================
   CLEANUP
========================= */
document.addEventListener("shopify:section:unload", function (event) {

  const sliders = event.target.querySelectorAll(".fr-swiper");

  sliders.forEach(function (slider) {
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }
  });

});